import { render, staticRenderFns } from "./removeGroupDialog.vue?vue&type=template&id=0643419b&"
import script from "./removeGroupDialog.vue?vue&type=script&lang=js&"
export * from "./removeGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports